(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/game/assets/javascripts/collection.js') >= 0) return;  svs.modules.push('/components/casino/game/assets/javascripts/collection.js');

'use strict';

class GamesCollection {
  constructor(gameList) {
    const games = {};
    gameList.forEach(game => {
      games[game.name] = new svs.components.casino.game.GameModel(game);
    });
    _.extend(this, games);
  }
}

setGlobal('svs.components.casino.game.GamesCollection', GamesCollection);

 })(window);